export default __webpack_public_path__ + "static/media/my-volunteer-mockup-1.a20d0d8a.png";